/* Accordion (FAQs + Growing Guides pages) — vanilla JS.
   v6 2026-08-19: jQuery left the theme with the PageFly purge, so the old
   WebSensePro $() accordion is rewritten without it. Same behaviour:
   one panel open at a time, click a header to toggle. */
document.addEventListener("click", function (e) {
  if (!e.target || !e.target.closest) { return; }
  var item = e.target.closest(".accordion > .accordion-item");
  if (!item) { return; }
  if (e.target.closest(".accordion-panel")) { return; }
  var list = item.parentElement;
  Array.prototype.forEach.call(list.children, function (sib) {
    if (sib !== item) { sib.classList.remove("is-active"); }
  });
  item.classList.toggle("is-active");
});

/* =====================================================================
   FUNGUY GIFT SYNC + CART UPSELL  (v6 — sole owner of the gift)
   Every 3 kits = 1 free Mystery Kit; pricing enforced server-side by the
   automatic BXGY discount. Native ecx-cart-drwr drawer is the primary
   cart surface; sections ride back on the same cart POSTs, no reloads.
   Gift line lock: entire stepper hidden (inputs stay in the DOM for
   positional updates[] posts), "N× FREE GIFT" badge outside any themed
   borders. Drawer banner mounts INSIDE ecx-cart-drwr-frm — the theme's
   drawer body is display:grid and stretches direct children (the tall
   beige box bug); inside the form wrapper it sits in normal flow.
   Watches fetch AND XHR; re-reads the cart at action time; one
   key-addressed write per pass.
   ===================================================================== */
(function () {
  "use strict";
  var KIT_PRODUCTS = { "7506649481267": 1, "7488640811059": 1 };
  var MYSTERY_PRODUCT = "7405238321203";
  var MYSTERY_VARIANT = 42595932143667;
  var GIFT_PROP = { "_gift": "FREE with every 3 kits" };
  var DRAWER_SECTION = "cart-drawer";
  var busy = false;
  var pending = false;
  var timer = null;
  var origFetch = window.fetch.bind(window);

  function isCartUrl(url) {
    return typeof url === "string" && (url.indexOf("/cart/add") !== -1 ||
      url.indexOf("/cart/change") !== -1 || url.indexOf("/cart/update") !== -1 ||
      url.indexOf("/cart/clear") !== -1);
  }
  function scheduleSync() {
    clearTimeout(timer);
    timer = setTimeout(afterMutation, 250);
  }

  function jfetch(url, opts) {
    opts = opts || {};
    opts.headers = opts.headers || {};
    opts.headers["Accept"] = "application/json";
    if (opts.body) { opts.headers["Content-Type"] = "application/json"; }
    return origFetch(url, opts).then(function (r) { return r.json(); });
  }
  function readCart() { return jfetch("/cart.js"); }

  function isGiftLine(item) {
    if (String(item.product_id) !== MYSTERY_PRODUCT) { return false; }
    return JSON.stringify(item.properties || {}).toLowerCase().indexOf("gift") !== -1;
  }

  function analyse(cart) {
    var kits = 0, giftQty = 0, giftLines = [], kitLines = [];
    (cart.items || []).forEach(function (it) {
      if (KIT_PRODUCTS[String(it.product_id)]) { kits += it.quantity; kitLines.push(it); }
      else if (isGiftLine(it)) { giftQty += it.quantity; giftLines.push(it); }
    });
    return { kits: kits, entitled: Math.floor(kits / 3), giftQty: giftQty,
             giftLines: giftLines, kitLines: kitLines };
  }

  function mainCartForm() {
    var forms = document.querySelectorAll('form[action="/cart"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].id !== "cart-drawer-form" && forms[i].closest('[id^="shopify-section-"]')) { return forms[i]; }
    }
    return null;
  }
  function cartSectionEl() {
    var form = mainCartForm();
    return form ? form.closest('[id^="shopify-section-"]') : null;
  }
  function sectionNames() {
    var names = [DRAWER_SECTION];
    if (window.location.pathname === "/cart") {
      var sec = cartSectionEl();
      if (sec) { names.push(sec.id.replace("shopify-section-", "")); }
    }
    return names.join(",");
  }

  function changeLine(key, qty, withSections) {
    var body = { id: key, quantity: qty };
    if (withSections) { body.sections = withSections; }
    return jfetch("/cart/change.js", { method: "POST", body: JSON.stringify(body) });
  }
  function addGift(qty, withSections) {
    var body = { items: [{ id: MYSTERY_VARIANT, quantity: qty, properties: GIFT_PROP }] };
    if (withSections) { body.sections = withSections; }
    return jfetch("/cart/add.js", { method: "POST", body: JSON.stringify(body) });
  }

  function applySections(resp) {
    if (!resp || !resp.sections) { return; }
    var dHtml = resp.sections[DRAWER_SECTION];
    var mine = document.getElementById("cartDrawer");
    if (dHtml && mine) {
      var dDoc = new DOMParser().parseFromString(dHtml, "text/html");
      var freshD = dDoc.getElementById("cartDrawer");
      if (freshD) { mine.innerHTML = freshD.innerHTML; }
    }
    var sec = cartSectionEl();
    if (sec) {
      var name = sec.id.replace("shopify-section-", "");
      var mHtml = resp.sections[name];
      if (mHtml) {
        var mDoc = new DOMParser().parseFromString(mHtml, "text/html");
        var freshM = mDoc.getElementById(sec.id);
        sec.innerHTML = freshM ? freshM.innerHTML : mHtml;
      }
    }
  }

  /* ------- gift line lock in EVERY cart form (page + drawer) ------- */
  function lockGiftRowsIn(form) {
    var links = form.querySelectorAll('a[href*="mystery"]');
    Array.prototype.forEach.call(links, function (a) {
      var row = null, node = a, hops = 0;
      while (node && node !== form && hops++ < 8) {
        if (node.querySelector && node.querySelector('input[name*="updates"], input[type="number"]')) {
          row = node; break;
        }
        node = node.parentElement;
      }
      if (!row || row.getAttribute("data-fg-locked")) { return; }
      var txt = (row.textContent || "").toLowerCase();
      if (txt.indexOf("$0.00") === -1 && txt.indexOf("free mystery") === -1) { return; }
      row.setAttribute("data-fg-locked", "1");

      var qtyInp = row.querySelector('input[name*="updates"], input[type="number"]');
      var giftQty = qtyInp ? (parseInt(qtyInp.value, 10) || 1) : 1;

      row.querySelectorAll('input[name*="updates"], input[type="number"]').forEach(function (inp) {
        inp.readOnly = true;
        inp.setAttribute("aria-disabled", "true");
        inp.style.pointerEvents = "none";
      });
      var stepper = null;
      row.querySelectorAll('ecx-cart-drwr-qty-inp, .field_quantity, [class*="quantity-wrapper"], [class*="qty-wrapper"]').forEach(function (w) {
        w.style.display = "none";
        if (!stepper) { stepper = w; }
      });
      row.querySelectorAll('button, a[href*="/cart/change"], [class*="remove"]').forEach(function (el) {
        if (el.closest && el.closest('a[href*="mystery"]')) { return; }
        var label = ((el.getAttribute("aria-label") || "") + " " + (el.className || "") + " " + (el.name || "")).toLowerCase();
        if (label.indexOf("remove") !== -1 || label.indexOf("minus") !== -1 || label.indexOf("plus") !== -1 ||
            label.indexOf("quantity") !== -1 || label.indexOf("delete") !== -1 ||
            (el.tagName === "A" && (el.getAttribute("href") || "").indexOf("/cart/change") !== -1)) {
          el.style.display = "none";
        }
      });
      if (!row.querySelector(".fg-gift-lock")) {
        var b = document.createElement("span");
        b.className = "fg-gift-lock";
        b.textContent = "🎁 " + (giftQty > 1 ? giftQty + "× " : "") + "FREE GIFT";
        if (stepper && stepper.parentElement) {
          stepper.parentElement.insertBefore(b, stepper);
        } else {
          row.appendChild(b);
        }
      }
    });
  }
  function lockGiftRows() {
    var forms = document.querySelectorAll('form[action="/cart"]');
    Array.prototype.forEach.call(forms, lockGiftRowsIn);
  }
  var lockObserver = null;
  function watchGiftRows() {
    if (lockObserver) { return; }
    lockObserver = new MutationObserver(function () { lockGiftRows(); });
    lockObserver.observe(document.body, { childList: true, subtree: true });
  }

  function syncNow() {
    if (busy) { return Promise.resolve({ changed: false }); }
    busy = true;
    var names = sectionNames();
    return readCart().then(function (cart) {
      var a = analyse(cart);
      if (a.giftQty === a.entitled) { return { changed: false }; }
      var added = a.entitled > a.giftQty;
      var op;
      if (a.giftLines.length > 1) {
        op = changeLine(a.giftLines[a.giftLines.length - 1].key, 0, names);
      } else if (a.entitled === 0) {
        op = changeLine(a.giftLines[0].key, 0, names);
      } else if (a.giftLines.length === 1) {
        op = changeLine(a.giftLines[0].key, a.entitled, names);
      } else {
        op = addGift(a.entitled, names);
      }
      return op.then(function (resp) {
        return { changed: true, added: added, entitled: a.entitled, resp: resp,
                 rerun: a.giftLines.length > 1 };
      });
    }).then(function (res) { busy = false; return res; })
      .catch(function () { busy = false; return { changed: false }; });
  }

  function applyResult(res) {
    if (res.changed && res.resp) { applySections(res.resp); }
    lockGiftRows();
    renderBanners();
    if (res.changed && res.added) { fanfare(res.entitled); }
  }

  function afterMutation() {
    if (busy) { pending = true; return; }
    syncNow().then(function (res) {
      applyResult(res);
      if (res.rerun || pending) { pending = false; setTimeout(afterMutation, 250); }
    });
  }

  window.fetch = function (input, init) {
    var url = (typeof input === "string") ? input : (input && input.url) || "";
    var p = origFetch(input, init);
    if (isCartUrl(url)) {
      p.then(scheduleSync).catch(function () {});
    }
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__fgCart = isCartUrl(url);
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__fgCart) {
      this.addEventListener("loadend", scheduleSync);
    }
    return origSend.apply(this, arguments);
  };

  /* ---------------- upsell ladder + fanfare ---------------- */
  function money(cents) { return "$" + (cents / 100).toFixed(2); }

  function runUpsell(action) {
    var names = sectionNames();
    return readCart().then(function (cart) {
      var a = analyse(cart);
      if (action === "add1") {
        var v = a.kitLines.length ? a.kitLines[0].variant_id : 42950241583155;
        return jfetch("/cart/add.js", { method: "POST",
          body: JSON.stringify({ items: [{ id: v, quantity: 1 }], sections: names }) });
      }
      var updates = {};
      a.kitLines.forEach(function (line) {
        updates[String(line.variant_id)] = (updates[String(line.variant_id)] || 0) + line.quantity;
      });
      Object.keys(updates).forEach(function (vid) { updates[vid] = updates[vid] * 2; });
      return jfetch("/cart/update.js", { method: "POST",
        body: JSON.stringify({ updates: updates, sections: names }) });
    }).then(function (resp) {
      return syncNow().then(function (res) {
        if (!res.changed) { applySections(resp); }
        applyResult(res);
      });
    });
  }

  function buildBanner(a, unitPrice, idSuffix) {
    var box = document.createElement("div");
    box.id = "fg-upsell" + (idSuffix || "");
    box.className = "fg-upsell-box";
    var head = "", body = "", btnLabel = "", action = null;
    if (a.kits === 1) {
      head = "🚚 You're 1 kit away from FREE SHIPPING";
      body = "Add a 2nd kit and shipping's on us — save $10.";
      btnLabel = "Add another kit → " + money(unitPrice);
      action = "add1";
    } else if (a.kits === 2) {
      head = "🎁 You're 1 kit away from a FREE Mystery Kit";
      body = "Add a 3rd kit and we'll throw in a Mystery Kit ($39.90 value) — free.";
      btnLabel = "Add a 3rd kit → " + money(unitPrice);
      action = "add1";
    } else if (a.kits >= 3 && a.kits < 6) {
      head = "🍄 Double your order → 2 FREE Mystery Kits";
      body = "One click doubles every kit in your cart. Every 3 kits = another free Mystery Kit.";
      btnLabel = "Double my order";
      action = "double";
    } else if (a.kits >= 6) {
      var rem = a.kits % 3;
      var need = rem === 0 ? 3 : 3 - rem;
      head = "🎉🍄 Legend! " + a.entitled + " FREE Mystery Kits unlocked";
      body = "Every 3 kits earns another free Mystery Kit. " + need + " more kits = your next one.";
    }
    if (!head) { return null; }
    var h = document.createElement("div"); h.className = "fg-upsell-head"; h.textContent = head;
    var b = document.createElement("div"); b.className = "fg-upsell-body"; b.textContent = body;
    box.appendChild(h); box.appendChild(b);
    if (action) {
      var btn = document.createElement("button");
      btn.type = "button"; btn.className = "fg-upsell-btn"; btn.textContent = btnLabel;
      btn.addEventListener("click", function () {
        btn.disabled = true; btn.textContent = "Adding…";
        runUpsell(action).catch(function () { window.location.reload(); });
      });
      box.appendChild(btn);
    }
    return box;
  }

  function renderBanners() {
    readCart().then(function (cart) {
      var a = analyse(cart);
      var unitPrice = a.kitLines.length ? a.kitLines[0].price : 3990;
      var old = document.getElementById("fg-upsell");
      if (old) { old.remove(); }
      if (window.location.pathname === "/cart" && a.kits) {
        var pageBanner = buildBanner(a, unitPrice, "");
        var anchor = mainCartForm();
        if (pageBanner && anchor) { anchor.parentElement.insertBefore(pageBanner, anchor); }
        else if (pageBanner) {
          var main = document.querySelector("main") || document.body;
          main.insertBefore(pageBanner, main.firstChild);
        }
      }
      var oldD = document.getElementById("fg-upsell-drawer");
      if (oldD) { oldD.remove(); }
      if (a.kits) {
        /* mount INSIDE the form wrapper — the drawer body is display:grid
           and stretches direct children into tall beige boxes */
        var host = document.querySelector("#ecxCartDrawer ecx-cart-drwr-frm") ||
                   document.querySelector("#ecxCartDrawer .drawer__body");
        if (host) {
          var dBanner = buildBanner(a, unitPrice, "-drawer");
          if (dBanner) { host.insertBefore(dBanner, host.firstChild); }
        }
      }
    });
  }

  function fanfare(count) {
    var old = document.getElementById("fg-fanfare");
    if (old) { old.remove(); }
    var f = document.createElement("div");
    f.id = "fg-fanfare";
    f.textContent = count > 1
      ? "🎉🍄🍄 " + count + " FREE Mystery Kits in your cart!"
      : "🍄🎉 FREE Mystery Kit added to your cart!";
    document.body.appendChild(f);
    setTimeout(function () { f.classList.add("show"); }, 50);
    setTimeout(function () { f.classList.remove("show"); }, 4500);
    setTimeout(function () { f.remove(); }, 5200);
  }

  function injectStyles() {
    if (document.getElementById("fg-upsell-css")) { return; }
    var s = document.createElement("style");
    s.id = "fg-upsell-css";
    s.textContent = "" +
      ".fg-upsell-box{font-family:'Poppins',sans-serif;background:#fdf6e3;border:1px solid #f3e2b0;" +
        "border-radius:12px;padding:14px 16px;margin:0 0 16px;}" +
      "#fg-upsell-drawer{margin:0 12px 14px;flex:0 0 auto !important;align-self:start;" +
        "height:auto !important;}" +
      "#ecxCartDrawer .drawer__header{padding-bottom:10px !important;}" +
      "#ecxCartDrawer .drawer__body{padding-top:8px !important;}" +
      ".fg-upsell-box .fg-upsell-head{font-weight:700;font-size:14.5px;color:#222;margin-bottom:4px;}" +
      ".fg-upsell-box .fg-upsell-body{font-size:13px;color:#555;line-height:1.5;margin-bottom:10px;}" +
      ".fg-upsell-box .fg-upsell-btn{min-height:44px;padding:0 20px;background:#f8c040;color:#111;" +
        "font-weight:700;font-size:14px;border:0;border-radius:8px;cursor:pointer;}" +
      ".fg-upsell-box .fg-upsell-btn[disabled]{opacity:.7;cursor:wait;}" +
      ".fg-gift-lock{display:inline-flex;align-items:center;gap:4px;background:#2e6f4e;color:#fff;" +
        "font-family:'Poppins',sans-serif;font-weight:700;font-size:11.5px;letter-spacing:.03em;" +
        "padding:7px 12px;border-radius:999px;border:0;outline:0;box-shadow:none;white-space:nowrap;" +
        "line-height:1;}" +
      "[data-fg-locked] .fg-gift-lock{margin:2px 0;}" +
      "#fg-fanfare{position:fixed;top:18px;left:50%;transform:translate(-50%,-80px);" +
        "background:#2e6f4e;color:#fff;font-family:'Poppins',sans-serif;font-weight:700;" +
        "font-size:15px;padding:14px 22px;border-radius:10px;box-shadow:0 8px 24px rgba(0,0,0,.25);" +
        "z-index:2147483000;transition:transform .4s ease;}" +
      "#fg-fanfare.show{transform:translate(-50%,0);}";
    document.head.appendChild(s);
  }

  function init() {
    injectStyles();
    lockGiftRows();
    watchGiftRows();
    syncNow().then(applyResult);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();